module.exports = __webpack_public_path__ + "img/abebech_debebe_square.a8e975d8.png";